import { render, staticRenderFns } from "./oldList.vue?vue&type=template&id=397ac29c&scoped=true"
import script from "./oldList.vue?vue&type=script&lang=js"
export * from "./oldList.vue?vue&type=script&lang=js"
import style0 from "./oldList.vue?vue&type=style&index=0&id=397ac29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ac29c",
  null
  
)

export default component.exports